import { Location } from "history";

import { makeAddValueToLinkState } from "seneca-common/utils/routing";

import { linkToDashboard } from "features/dashboard/links";
import { LinkedAccountsSource } from "features/settings/features/linked-accounts/analytics";

export function linkToSettings() {
  return `${linkToDashboard()}/settings`;
}

export function linkToPersonalInformation() {
  return `${linkToSettings()}/personal-information`;
}

export function linkToLinkedAccounts() {
  return `${linkToSettings()}/linked-accounts`;
}

export function makeLinkToLinkedAccounts(options: {
  source: LinkedAccountsSource;
}): Location {
  return makeAddValueToLinkState(options)(linkToLinkedAccounts());
}

export function linkToChangeAvatar() {
  return `${linkToPersonalInformation()}/change-avatar`;
}

export function linkToChangeEmail() {
  return `${linkToPersonalInformation()}/change-email`;
}

export function linkToPasswordUpdate() {
  return `${linkToSettings()}/password`;
}

export function linkToUpgradeSubscription() {
  return `${linkToSettings()}/premium`;
}

export function linkToCancelSubscription(
  subscriptionId: string = ":subscriptionId"
) {
  return `${linkToUpgradeSubscription()}/cancel/${subscriptionId}`;
}

export function linkToRestartSubscription(
  subscriptionId: string = ":subscriptionId"
) {
  return `${linkToUpgradeSubscription()}/restart/${subscriptionId}`;
}

export function linkToUpdatePaymentDetails(
  subscriptionId: string = ":subscriptionId"
) {
  return `${linkToUpgradeSubscription()}/payment-details/${subscriptionId}`;
}

export function linkToAddParentByCode(code: string = ":code") {
  return `${linkToLinkedAccounts()}/parent/code/${code}/connect`;
}

export function linkToRemoveParent(parentId: string = ":parentId") {
  return `${linkToLinkedAccounts()}/parent/${parentId}/disconnect`;
}
